var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoEquipment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "o9aubph9xa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.662745 0 0 0 0 0.992157 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#00A9FD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.241 20.578h3.295V16.51s-2.608-3.546-7.72-3.546c0 0-2.294-3.234-5.945-3.964h-6.78s-2.608.417-6.259 3.86H1.85s-.626 1.043-.626 4.38c0 0-.417 3.338 2.191 3.338h.991M10.352 20.578h10.944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.835 13.485-1.147.626h-9.91L8.37 12.703M10.352 20.578a2.973 2.973 0 1 1-5.946 0 2.973 2.973 0 0 1 5.946 0zM27.241 20.578a2.973 2.973 0 1 1-5.945 0 2.973 2.973 0 0 1 5.945 0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoEquipment);
export default __webpack_public_path__ + "static/media/PictoEquipment.25d025a5275598fe80a780fd6d338f09.svg";
export { ForwardRef as ReactComponent };